module.exports = __webpack_public_path__ + "660394bb3bebc1adbe3b16e725e2311b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/vokabular_unclear.svg
// module id = 69
// module chunks = 0